import { Injectable } from '@angular/core';
import { requestWithToken } from 'src/config';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root'
})
export class AdminProdcutService {
 
   

  constructor(private utility : UtilityService){}

  getProductListing(queryParams: any) {
    return requestWithToken("GET",`/admin/products${queryParams}`).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  getMasters(name: any) {
    return requestWithToken( "GET",`/masters/${name}`,).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  updateStatus(queryParams : any){
    return requestWithToken("GET",`/admin/product/status${queryParams}`).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

//   async getProductListing(prodName: string, page: number, pageSize: number) {
//     return requestWithToken(
//         "GET",
//         `/user/product/list?prodname=${prodName}&pageNo=${page}&pageSize=${pageSize}`
//     )
// }

async getProductById(id: number) {
    return requestWithToken(
        "GET",
        `/admin/product/${id}`
    )
}

async addProductToFavorites(productVariantId: number, type: number) {
    return requestWithToken(
        "PUT",
        `/user/product/tooglefavourite/${productVariantId}/${type}`,
        {}
    )
}

async getProductCategories() {
    return requestWithToken(
        "GET",
        `/masters/prodCategory`
    )
}

async getAvailableBranch() {
    return requestWithToken(
        "GET",
        `/user/available-branches`
    )
}

async getProductSubCategories(catId: string) {
    return requestWithToken(
        "GET",
        `/masters/subCategory?catId=${catId}`
    )
}

async getSubCategoryVarients(subCatId: string) {
    return requestWithToken(
        "GET",
        `/masters/subCategoryVariants?subCatId=${subCatId}`
    )
}

async getVarientOptions(variantId: string) {
    return requestWithToken(
        "GET",
        `/masters/variantOptions?variantId=${variantId}`
    )
}
async getProductTypes() {
    return requestWithToken(
        "GET",
        `/masters/prodType`
    )
}
async getPackageType() {
    return requestWithToken(
        "GET",
        `/masters/packType`
    )
}
async getDelDistance() {
    return requestWithToken(
        "GET",
        `/masters/delDistance`
    )
}
async getWeightUnits() {
    return requestWithToken(
        "GET",
        `/masters/weightUnit`
    )
}
async getProductStatus() {
    return requestWithToken(
        "GET",
        `/masters/prodStatus`
    )
}
async getStockStatus() {
    return requestWithToken(
        "GET",
        `/masters/stockStatus`
    )
}
async getServiceType() {
    return requestWithToken(
        "GET",
        `/masters/serviceType`
    )
}
async getServiceDuration() {
    return requestWithToken(
        "GET",
        `/masters/duration`
    )
}
async uploadFile(payload: any) {
    return requestWithToken(
        "POST",
        "/admin/document",
        payload
    )
}
async saveProduct(payload: any) {
    return requestWithToken(
        "POST",
        "/admin/product/save",
        payload
    )
}
async deleteVarient(varientId: number) {
    return requestWithToken(
        "DELETE",
        `/admin/product/variant/${varientId}`
    )
}
async deleteProduct(productId: number) {
    return requestWithToken(
        "DELETE",
        `/user/product/${productId}`
    )
}

}
